<template>
  <div>
    <ls-table-layout>
      <div slot="search">
        <ls-search-form @search="onSearch" @reset="onReset" :formList="formList">
          <a-select allowClear :dropdown-match-select-width="false" slot="pantone" v-model="queryParams.pantone" option-filter-prop="children" option-label-prop="label" mode="multiple" :max-tag-text-length="2" :max-tag-count="1">
            <a-select-option v-for="(item) in pantoneSelectList" :key="item.realValue" :value="item.realValue" :label="item.label">
              {{ item.label }}
            </a-select-option>
          </a-select>
          <a-select allowClear v-decorator="['version', { rules: [{ required: true, message: '版本号不能为空' }] }]" :dropdown-match-select-width="false" slot="version" v-model="queryParams.version" option-filter-prop="children" option-label-prop="label">
            <a-select-option v-for="(item) in versionSelectList" :key="item.realValue" :value="item.realValue" :label="item.label">
              {{ item.label }}
            </a-select-option>
          </a-select>
          <a-select allowClear :dropdown-match-select-width="false" slot="organizationCode" v-model="queryParams.organizationCode" option-filter-prop="children" option-label-prop="label" mode="multiple" :max-tag-text-length="2" :max-tag-count="1">
            <a-select-option v-for="(item) in inventOrg" :key="item.realValue" :value="item.realValue" :label="item.label">
              {{ item.realValue }}-{{ item.label }}
            </a-select-option>
          </a-select>
        </ls-search-form>
      </div>
      <div slot="btn">
        <a-space>
          <download-modal :apiFun="apiMesGrossRequirementNewExport" ref="download" />
          <a-button v-hasPermi="['mes:mesGrossRequirement:buildVersion']" type="primary" @click="handleGenVersion" :loading="isGenVersionBtnLoading">生成版本</a-button>
          <a-button type="primary" @click="handleExport" v-hasPermi="['mes:mesGrossRequirement:grossRequirementExport']">导出</a-button>
        </a-space>
      </div>
      <div slot="table">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :table-props="tableProps"
          @successCallBack="handleLoadTableDataFinish"
          :scroll="{x: '100%', fixScreen: true}"
        >
        </ls-api-table>
      </div>
    </ls-table-layout>
    <a-modal :visible="isShowConfirmGenVersionModal" :mask-closable="false" :closable="false" @ok="handleGenVersionConfirm" @cancel="handleGenVersionCancel" :confirm-loading="isConfirmGenVersionBtnLoading">
      <div class="gen-version-modal-title">
        <a-icon type="question-circle" class="gen-version-modal-icon"/>
        <div class="gen-version-modal-content" style="line-height: 22px;">
          <span>该操作将保存</span>
          <a-select allowClear v-model="currentSelectedLastVersion" size="small" default-value="lucy" style="width: 180px">
            <a-select-option :value="item.realValue" v-for="item in lastVersionSelectList" :key="item.realValue">
              {{ item.label }}
            </a-select-option>
          </a-select>
          <span>为上一版本需求数量，{{ nextVersionText }}为最新版本的需求数量</span>
          <a-form labelAlign="left" class="gen-version-data-form" :form="genVersionFormData" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
            <a-form-item label="工单状态">
              <a-select mode="multiple" show-search option-filter-prop="children" v-model="genVersionFormData.jobStatus" allowClear maxTagCount="2">
                <a-select-option v-for="item in statusList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="工单完工时间">
              <a-date-picker placeholder="请选择时间" v-model="genVersionFormData.cutoffDate" valueFormat="YYYY-MM-DD 00:00:00" />
            </a-form-item>
            <!-- <a-form-item label="仓库类型">
              <global-select
                select-type="selectMultiple"
                v-model="genVersionFormData.subinventory"
                :selectData="subinventoryTypeList"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
              />
            </a-form-item> -->
          </a-form>
          <div class="gen-version-modal-tip">请确认是否继续</div>
        </div>
      </div>
      <a-modal v-model="msgShow" :width="480" ok-text="确认" :zIndex="1001" :destroyOnClose="true" :closable="false" @ok="hideMsgModal">
        <div class="msg-title">
          <a-icon type="check-circle" :style="{ fontSize: '22px', color: '#52c41a' }" v-if="msgData.code===200" />
          <a-icon type="close-circle" :style="{ fontSize: '22px', color: '#ff4d4f' }" v-else />
          <span>提示</span>
        </div>
        <div v-html="msgData.msg" style="margin-left: 30px" />
        <template slot="footer">
          <a-button :type="msgData.code===200?'primary':'danger'" @click="hideMsgModal">确定</a-button>
        </template>
      </a-modal>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  apiGetGrossRequirementList,
  apiGetSelectLastVersion,
  apiGetSelectNextVersion,
  apiPostBuildVersion,
  apiMesGrossRequirementNewExport,
  apiGetPantoneSelectList,
  apiGetVersionSelectList
} from '@/api/scp/factoryCallMaterial/materialGrossDemandReport'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
// import moment from 'moment'

export default {
  name: 'MaterialGrossDemandReport',
  components: { DownloadModal },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      userName: (state) => state.user.name
    })
  },
  data () {
    return {
      apiMesGrossRequirementNewExport,
      msgShow: false, // 是否展示失败信息弹窗
      msgData: { msg: '', code: 200 },
      formList: [
        {
          label: '版本号',
          type: 'version'
        },
        {
          label: '加工组织',
          type: 'organizationCode'
        },
        {
          label: '潘通色号',
          type: 'pantone'
        },
        {
          label: '物料编码',
          decorator: ['itemCode'],
          type: 'input'
        }
      ],
      frontColumns: [
      {
          title: '潘通色号',
          dataIndex: 'pantone',
          width: 120,
          customRender: (value, row, index) => this.renderCell(value, row, index, ['pantone'])
        },
        {
          title: '加工组织',
          dataIndex: 'organizationName',
          width: 120,
          customRender: (value, row, index) => this.renderCell(value, row, index, ['organizationName'])
        },
        {
          title: '供应商',
          dataIndex: 'supplierName',
          width: 200,
          ellipsis: true,
          customRender: (value, row, index) => this.renderCell(value, row, index, ['supplierName'])
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          width: 120,
          customRender: (value, row, index) => this.renderCell(value, row, index, ['itemCode'])
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          width: 150,
          customRender: (value, row, index) => this.renderCell(value, row, index, ['itemCode']),
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          width: 200,
          customRender: (value, row, index) => this.renderCell(value, row, index, ['itemCode']),
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'primaryUom',
          width: 100,
          customRender: (value, row, index) => this.renderCell(value, row, index, ['itemCode'])
        },
        {
          title: '剩余需求',
          dataIndex: 'remainderQuantityOpen',
          width: 100,
          customRender: (value, row, index) => this.renderCell(value, row, index, ['remainderQuantityOpen', 'itemCode'])
        },
        {
          title: '新增需求',
          dataIndex: 'newQuantityOpen',
          width: 100,
          customRender: (value, row, index) => this.renderCell(value, row, index, ['newQuantityOpen', 'itemCode'])
        }
      ],
      qtyColumns: [],
      nextColumns: [
        { title: '上一版本', dataIndex: 'lastVersion', width: 120 },
        { title: '创建人', dataIndex: 'createName', width: 100 },
        { title: '版本号', dataIndex: 'version', width: 120 }
      ],
      columns: [
        // {
        //   title: '工厂批次号',
        //   dataIndex: 'lotNumber',
        //   width: 150,
        //   ellipsis: true
        // },
        // {
        //   title: '工厂现有量',
        //   dataIndex: 'canQty',
        //   width: 120
        // },
        // {
        //   title: '工厂仓库',
        //   dataIndex: 'subinventory',
        //   width: 100
        // },
        // {
        //   title: '仓库类型',
        //   dataIndex: 'warehouseName',
        //   width: 100
        // },
      ],
      tableProps: {
        requestApi: generateLsTableResData(apiGetGrossRequirementList, true)
      },
      queryParams: {
        organizationCode: [],
        itemCode: '',
        pantone: [],
        version: ''
      },
      genVersionFormData: {
        // subinventory: ["1", "2"],
        cutoffDate: '',
        jobStatus: []
      },
      startDateRange: [],
      subinventoryTypeList: [], // 仓库类型快码列表
      statusList: [], // 工单状态快码列表
      lastVersionSelectList: [], // 上一版本下拉框
      currentSelectedLastVersion: '', // 当前选中的上一版本
      nextVersionText: '', // 最新版本
      versionSelectList: [], // 版本号下拉选择框
      pantoneSelectList: [], // 潘通色号下拉选择框
      isShowConfirmGenVersionModal: false, // 是否显示生成版本模态框
      isGenVersionBtnLoading: false, // 生成版本按钮loading状态
      isConfirmGenVersionBtnLoading: false // 确认生成版本按钮loading状态
    }
  },
  created () {
    this.msgShow = false;
    this.getLookupList('INV_SUBINVENTORY_TYPES', 'subinventoryTypeList')
    this.getLookupList('MES_JOB_STATUS', 'statusList')
    apiGetPantoneSelectList({ pageNum: 1, pageSize: 999 }).then(res => {
      this.pantoneSelectList = res.rows.filter(item => item !== null) || []
    })
    apiGetVersionSelectList({ pageNum: 1, pageSize: 999 }).then(res => {
      this.versionSelectList = res.rows.filter(item => item !== null) || []
    })
  },
  mounted () {
    // this.onSearch()
  },
  methods: {
    // 重新查询一次，获取到数据后，设置表头
    searchToSetTittle(params) {
      const paramsVal = {
        ...params,
        pageNum: 1,
        pageSize: 20
      }
      const dateColumn = []
      this.qtyColumns = []
      apiGetGrossRequirementList(paramsVal).then(res => {
        if(res?.code === 200 && res?.titleList?.length > 0) {
          // 日期和qty顺序一一对应
          res.titleList.forEach((item, index) => {
            dateColumn.push({
              title: item,
              dataIndex: `qty${index + 1}`,
              width: 80
            })
          })
          this.qtyColumns = dateColumn
          this.columns = this.frontColumns.concat(this.qtyColumns, this.nextColumns)
        }
      })
    },
    onSearch (value = {}) {
      if (!this.queryParams.version) {
        this.$message.error('请先选择版本号')
        return
      }
      const params = {
       ...this.queryParams,
       ...value
      }
      delete params.searchFormLabel;
      this.searchToSetTittle(params) // 设置表头
      this.$refs.dataTable.searchParams = params;
      this.$refs.dataTable.getData();
    },
    handleExport () {
      if (!this.queryParams.version) {
        this.$message.error('请先选择版本号')
        return
      }
      const params = {
       ...this.$refs.dataTable.searchParams
      }
      delete params.searchFormLabel;
      this.$refs.download.openModal(params)
      // this.download('mes/mesGrossRequirement/grossRequirementExport', {
      //   ...params
      // }, `原材料毛需求报表_${new Date().getTime()}.xlsx`)
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        if (type === 'MES_JOB_STATUS') {
          this[arr] = response.rows.filter(item => item.attribute1 === 'Y')
        } else {
          this[arr] = response.rows
        }
      })
    },
    handleLoadTableDataFinish (data) {
      console.log(data)
      // console.log(...arguments)
      // const tempQtyColumns = []
      // for (const key in data[0]) {
      //   if (Object.hasOwnProperty.call(data[0], key)) {
      //     if (key.match(/^qty\d+$/)) {
      //       // 获取当前年份的前两位数字
      //       const currentYearPrefix = new Date().getFullYear().toString().slice(0, 2);
      //       // 提取version的中间4位作为月份和日期，并与当前年份的前两位拼接
      //       const versionDate = currentYearPrefix + data[0].version.substring(2, 6);
      //       // 获取qty后面的数字作为addDays的值
      //       const addDays = parseInt(key.slice(3)) || 0;
      //       tempQtyColumns.push({
      //         title: moment(versionDate, 'YYMMDD').add(addDays - 1, 'days').format('MM/DD'),
      //         dataIndex: key,
      //         width: 80
      //       })
      //     }
      //   }
      // }
      // this.qtyColumns = tempQtyColumns
      // this.columns = this.frontColumns.concat(this.qtyColumns, this.nextColumns)
    },
    renderCell (value, row, index, dataIndexArray) {
      const dataSource = this.$refs.dataTable.myDataSource;
      const currentValues = dataIndexArray.map(dataIndex => row[dataIndex]);
      const prevRow = index > 0 ? dataIndexArray.map(dataIndex => dataSource[index - 1][dataIndex]) : null;

      const obj = {
        children: value,
        attrs: {}
      };

      // 判断当前行的值与前一行是否相同，如果相同，则合并单元格
      if (prevRow && prevRow.every((prevValue, i) => prevValue === currentValues[i])) {
        obj.attrs.rowSpan = 0;
      } else {
        // 计算相同值出现的次数，设置 rowSpan
        let rowSpan = 1;
        for (let i = index + 1; i < dataSource.length; i++) {
          const nextValues = dataIndexArray.map(dataIndex => dataSource[i][dataIndex]);
          if (nextValues.every((nextValue, j) => nextValue === currentValues[j])) {
            rowSpan++;
          } else {
            break;
          }
        }
        obj.attrs.rowSpan = rowSpan;
      }

      return obj;
    },
    onReset () {
      this.startDateRange = []
      this.queryParams = {
        organizationCode: [],
        itemCode: '',
        // subinventory: ["1", "2"],
        jobStatus: [],
        startDateFrom: '',
        startDateTo: ''
      }
      this.dataTable.searchParams = this.queryParams
    },
    handleGenVersion () {
      this.isGenVersionBtnLoading = true
      Promise.all([apiGetSelectLastVersion(), apiGetSelectNextVersion()]).then(res => {
        this.nextVersionText = res[1]
        this.lastVersionSelectList = res[0].rows
        if (res[0].rows[0] && res[0].rows[0].realValue) {
          this.currentSelectedLastVersion = res[0].rows[0].realValue
        }
        this.isShowConfirmGenVersionModal = true
        this.isGenVersionBtnLoading = false
      }).catch(() => {
        this.isGenVersionBtnLoading = false
      })
    },
    // 关闭消息模态框
    hideMsgModal() {
      this.msgShow = false
    },
    handleGenVersionConfirm () {
      this.isConfirmGenVersionBtnLoading = true
      apiPostBuildVersion({
        operName: this.userName,
        lastVersion: this.currentSelectedLastVersion ? this.currentSelectedLastVersion.toString() : '',
        version: this.nextVersionText ? this.nextVersionText.toString() : '',
        ...this.genVersionFormData
      }).then(res => {
        if (res.code === 200) {
          // 根据里层code判断是否执行成功
          if(!res?.data) {
            this.$message.success(res.msg)
          } else if(res?.data?.code === 200) {
            this.msgData = { msg: res?.data?.msg || '操作成功', code: res.data.code }
            this.msgShow = true;
          } else {
            this.msgData = { msg: res?.data?.msg || '操作失败', code: res?.data?.code || 500 }
            this.msgShow = true;
          }
        } else {
          this.$message.error(res.msg)
        }
        this.handleGenVersionModalClose() // 关闭弹窗，确认每次都新生成版本
        this.isConfirmGenVersionBtnLoading = false
      }).catch(() => {
        this.isConfirmGenVersionBtnLoading = false
      })
    },
    handleGenVersionCancel () {
      this.handleGenVersionModalClose()
    },
    handleGenVersionModalClose () {
      this.isShowConfirmGenVersionModal = false
      // this.genVersionFormData.subinventory = ["1", "2"]
      this.genVersionFormData.cutoffDate = ''
      this.genVersionFormData.jobStatus = []
    }
  }
}
</script>

<style scoped lang="less">
.gen-version-modal-title {
  line-height: 22px;
  display: flex;
  color: rgba(0, 0, 0, 0.85);
  .gen-version-modal-icon {
    font-size: 22px;
    color: #faad14;
    margin-right: 10px;
  }
  .gen-version-modal-content {
    line-height: 22px;
    font-weight: bold;
  }
  .gen-version-modal-tip {
    margin-top: 10px;
    font-weight: normal;
  }
  .gen-version-data-form {
    /deep/.ant-form-item {
      margin: 5px 0;
    }
  }
}
.msg-title{
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 5px;
  span{
    margin-left: 10px;
  }
}
</style>
